import React from 'react';
import Status from '../components/Status';
import { colors } from '../constants/colors';

// Сделка, заведённая клиентом из мобильного приложения, помечена в списке; у остальных пусто.
export const dealSourceLabel = (row) =>
  row?.source === 'app' ? <Status status="Приложение" color={colors.dimGray} /> : null;
